import { userStore, types } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";
// import { AxiosResponse } from "axios";

export default {
    async list(): Promise<types.ResMainViewList> {
        const res = {} as types.ResMainViewList;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/main/view/list", null, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async modify(param: types.ReqMainView): Promise<types.ResInquiry> {
        const res = {} as types.ResInquiry;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/main/view/modify", param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
};
